import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const validateInstanceEndpoint = async instanceId => {
  const endpoint = API_ENDPOINTS.VALIDATE_INSTANCE(instanceId);
  try {
    return await apiClient.post(endpoint, {});
  } catch (error) {
    throw new Error(`Error updating instance validation: ${error.message}`);
  }
};

export const unvalidateInstanceEndpoint = async instanceId => {
  const endpoint = API_ENDPOINTS.UNVALIDATE_INSTANCE(instanceId);
  try {
    return await apiClient.post(endpoint, {});
  } catch (error) {
    throw new Error(`Error updating instance validation: ${error.message}`);
  }
};

export const updateInstanceEndpoint = async (instanceId, payload) => {
  const endpoint = API_ENDPOINTS.UPDATE_INSTANCE(instanceId);
  try {
    const response = await apiClient.patch(endpoint, payload);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating instance: ${error.message}`);
  }
};

export const getInstanceThumbnailEndpoint = async (patientId, instanceId) => {
  try {
    const response = await apiClient.get(
      `${API_ENDPOINTS.GET_INSTANCE_THUMBNAIL(patientId, instanceId)}`,
      {
        responseType: "blob",
        // Suppress 404 errors in console
        validateStatus: status => status < 500,
      }
    );

    // If 404, return null instead of throwing
    if (response.status === 404) {
      return null;
    }

    return { data: response.data, contentType: response.data.contentType };
  } catch (error) {
    // Only throw for actual errors (500+)
    throw new Error(`Thumbnail not available: ${error.message}`);
  }
};

export const uploadInstanceEndpoint = async (
  patientId,
  imageFile,
  destination
) => {
  const formData = new FormData();
  formData.append("image", imageFile.file);
  formData.append("destination", destination);
  return apiClient
    .post(`${API_ENDPOINTS.UPLOAD_INSTANCE(patientId)}`, formData, {
      responseType: "json",
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw new Error(`Error fetching the images: ${error.message}`);
    });
};

export const processInstanceEndpoint = async (
  patientId,
  metadata = {},
  destination
) => {
  const parseIfString = value => {
    if (typeof value !== "string") return value;
    try { return JSON.parse(value); } catch { return value; }
  };

  const payload = {
    userInput: {
      ...metadata,
      orientation: parseIfString(metadata.orientation),
      originalOrientation: parseIfString(metadata.originalOrientation),
    },
    destination: destination,
  };
  return apiClient
    .put(`${API_ENDPOINTS.PROCESS_INSTANCE(patientId)}`, payload)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw new Error(`Error processing the image: ${error.message}`);
    });
};

export const rerunLandmarkingEndpoint = async (instanceId, metadata = {}) => {
  const endpoint = API_ENDPOINTS.RERUN_LANDMARKING(instanceId);
  try {
    const response = await apiClient.post(endpoint, metadata);
    return response.data;
  } catch (error) {
    throw new Error(`Error rerunning landmarking: ${error.message}`);
  }
};

export const deleteInstanceEndpoint = async instanceId => {
  const endpoint = API_ENDPOINTS.DELETE_INSTANCE(instanceId);
  try {
    const response = await apiClient.delete(endpoint);
    return response.data;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};
